module.exports = __webpack_public_path__ + "img/tron (25).58672887.jpg";